<template>
  <g id="typing-dots">
    <circle class="dot-1 stroke-none" cx="3" cy="10" r="2" />
    <circle class="dot-2 stroke-none" cx="10" cy="10" r="2" />
    <circle class="dot-3 stroke-none" cx="17" cy="10" r="2" />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "TypingDots",
  mixins: [IconMixin],
  data() {
    return {};
  }
};
</script>

<style scoped>
$animation-speed: 1s;

.dot-1 {
  animation: bounce $animation-speed ease infinite;
}
.dot-2 {
  animation: bounce $animation-speed 0.1s ease infinite;
}
.dot-3 {
  animation: bounce $animation-speed 0.2s ease infinite;
}
</style>        
        